import React from "react";

export const PILL_TYPES = {
  ENTITY: "ENTITY",
  PERCENTAGE: "PERCENTAGE",
  SEVERITY: "SEVERITY",
  ROUTE: "ROUTE",
};

const ActivityPill = ({
  children,
  type = PILL_TYPES.ENTITY,
  percentage,
  from,
  to,
  className = "",
}) => {
  console.log(from, to);
  if (type === PILL_TYPES.PERCENTAGE || percentage !== undefined) {
    const num = Number(percentage ?? parseFloat(children));
    let colorClass = "bg-alert-10 text-alert-red";
    if (num === 100) {
      colorClass = "bg-[#169757] text-white";
    } else if (num >= 50) {
      colorClass = "bg-warning-10 text-warning";
    }

    return (
      <span
        className={`inline-flex items-center justify-center font-poppins font-medium text-[11px] px-2 py-[2px] rounded-[4px] leading-tight ${colorClass} ${className}`}
      >
        {children ?? `${num}%`}
      </span>
    );
  }

  if (type === PILL_TYPES.SEVERITY) {
    return (
      <span
        className={`inline-flex items-center justify-center font-poppins font-medium text-[11px] px-2 py-[3px] rounded-[4px] leading-tight bg-warning-10 text-warning ${className}`}
      >
        {children}
      </span>
    );
  }

  if (type === PILL_TYPES.ROUTE || (from && to)) {
    return (
      <span
        className={`inline-flex items-center gap-x-1.5 font-poppins font-medium text-[11px] text-[#000000] px-2 py-[3px] rounded-[4px] leading-tight bg-[#E6EDEE] ${className}`}
      >
        <span>{from}</span>
        <span className="text-[#525252] text-[10px]">&gt;</span>
        <span>{to}</span>
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center font-poppins font-medium text-[11px] text-[#000000] px-2 py-[3px] rounded-[4px] leading-tight bg-[#E6EDEE] whitespace-nowrap ${className}`}
    >
      {children}
    </span>
  );
};

export default ActivityPill;
